import LoginPage from './components/LoginPage';

export const loginPage = {
  firstLevel: LoginPage,
};